import appConfig from '../config/app.json'

/**
 * Resuelve a qué backends habla la app según el hostname.
 *
 * En desarrollo los cuatro proyectos comparten la base `farmaval_probiomentor`:
 * farmavel (que sirve la API en farmavel.test), farmaval-server-v2 y
 * farmaval-v1. Si alguno apunta a otra base, el token se emite contra una y se
 * valida contra otra, y el iframe del servicio responde "Su sesión ha expirado".
 *
 * Antes de la unificación había dos bases y `api_url` tenía que ser
 * https://admin2.farmavel.test/api/; ya no, pero sigue siendo el error de
 * configuración más caro de diagnosticar del entorno: si las cifras que ve un
 * frontend no cuadran, sospecha del host antes que del código.
 */
export function getServerConfig() {
    const hostname = window.location.hostname
    let environment = 'production'

    // Development environment
    if (hostname === 'localhost' || hostname.endsWith('.test')) {
        environment = 'development'
    } else if (hostname.includes('staging')) {
        environment = 'staging'
    }

    const config = appConfig.environments[environment]

    return {
        server_base: config.backend_url,
        api_base: config.api_url || `${config.backend_url.replace(/\/$/, '')}/api/`,
        old_server_base: config.legacy_backend_url,
        assets_base_url: config.assets.base_url,
    }
}
